import React from "react";
import { useNavigate } from "react-router-dom";
import useDragScroll from "../../components/utils/useDragScroll";
import img1 from "../../assets/img/experience/vitaNotturna.jpg";
import img2 from "../../assets/img/experience/romantica.jpg";
import img3 from "../../assets/img/experience/ariaAperta.jpg";
import img4 from "../../assets/img/experience/business.png";
import img5 from "../../assets/img/experience/arteCultura.jpg";
import img6 from "../../assets/img/experience/city.jpg";
import img7 from "../../assets/img/experience/rilassante.jpg";
import img8 from "../../assets/img/experience/famiglia2.jpg";
import icon1 from "../../assets/icone/experience/iconVitaNottura.svg";
import icon2 from "../../assets/icone/experience/iconaRomanticoFill.svg";
import icon3 from "../../assets/icone/experience/iconaAreaApertaFill.svg";
import icon4 from "../../assets/icone/experience/iconaBusinessFill.svg";
import icon5 from "../../assets/icone/experience/iconaArteCulturaFill.svg";
import icon6 from "../../assets/icone/experience/iconaCityBreakFill.svg";
import icon7 from "../../assets/icone/experience/iconaRilassanteFill.svg";
import icon8 from "../../assets/icone/experience/iconaFamigliaFill.svg";
import { useTranslation } from "react-i18next";

const ExperienceCarousel = () => {
  const navigate = useNavigate();
  const { scrollRef, didDrag } = useDragScroll();
  const { t } = useTranslation();

  const cardsData = [
    { id: 1, imageUrl: img1, icon: icon1, experienceKey: "nightlife" },
    { id: 2, imageUrl: img2, icon: icon2, experienceKey: "romantic" },
    { id: 3, imageUrl: img3, icon: icon3, experienceKey: "outdoor" },
    { id: 4, imageUrl: img4, icon: icon4, experienceKey: "business" },
    { id: 5, imageUrl: img5, icon: icon5, experienceKey: "art_culture" },
    { id: 6, imageUrl: img6, icon: icon6, experienceKey: "city" },
    { id: 7, imageUrl: img7, icon: icon7, experienceKey: "relaxing" },
    { id: 8, imageUrl: img8, icon: icon8, experienceKey: "family" },
  ];

  const handleCardClick = (experienceKey) => {
    if (!didDrag) {
      navigate("/experience", { state: { experience: experienceKey } });
    }
  };

  return (
    <div className="flex flex-col py-10 border-b border-gray-300">
      <div className="flex justify-center my-8">
        <button
          onClick={() => navigate("/experience")}
          className="pt-2.5 pb-2 w-96 h-11 bg-wild-ocean text-white text-center font-heading text-lg rounded-lg"
        >
          {t("experience.carousel.discoverAll")}
        </button>
      </div>
      <div className="flex">
        <div
          className="lg:w-6 w-2 mx-4 h-full flex items-center font-heading justify-center"
          style={{ height: "18rem" }}
        >
          <span className="transform -rotate-90 whitespace-nowrap text-4xl font-semibold">
            {t("experience.carousel.title")}
          </span>
        </div>
        <div
          ref={scrollRef}
          className="flex space-x-4 md:space-x-6 w-full p-4 bg-smoky custom-scrollbar overflow-x-auto"
        >
          {cardsData.map((card) => (
            <div
              key={card.id}
              className="relative flex-shrink-0 transition-transform"
              style={{ width: "13rem" }}
              onClick={() => handleCardClick(card.experienceKey)}
            >
              <div className="w-full h-72 bg-gray-200 rounded-xl shadow-lg duration-300 transform hover:scale-105">
                <img
                  src={card.imageUrl}
                  alt={`Immagine ${card.id}`}
                  className="w-full h-full object-cover rounded-xl hover:brightness-110"
                  draggable="false"
                />
              </div>
              <div className="flex items-center justify-center mt-4 space-x-2">
                {card.icon && (
                  <img
                    src={card.icon}
                    alt={`Icona ${card.id}`}
                    className="w-6"
                    draggable="false"
                  />
                )}
                <p className="font-heading uppercase pt-1 text-lg font-semibold text-left">
                  {t(`experience.carousel.cards.${card.experienceKey}`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExperienceCarousel;
